// fuels/my-model
import { getData } from 'src/services/RestApi';
import { formatDate, currentSeconds } from 'src/utils/date-locale';
import StringUtils from 'src/utils/string-util';
import { dayColor, paymentColor } from 'src/utils/color-rules';
import { formatQuantity, calculateTotalFuel } from 'src/utils/formatters';

export const getMyFuels = async (
  payload, {},
  onEndPoint = () => {},
  onSuccess = () => {},
  onError = () => {},
) => {
  const endPoint = 'api/fuel/my-list';
  onEndPoint(endPoint);

  const { result, error } = await getData(endPoint, payload);
  if (error) return onError(error);

  handleListResult(result);
  return onSuccess(result);
};

export const getFuels = async (
  payload, {},
  onEndPoint = () => {},
  onSuccess = () => {},
  onError = () => {},
) => {
  const endPoint = 'api/fuel/list';
  onEndPoint(endPoint);

  const { result, error } = await getData(endPoint, payload);
  if (error) return onError(error);

  if (result) {
    handleListResult(result);
  }
  return onSuccess(result);
};

export const getFullFuels = async (
  payload, {},
  onEndPoint = () => {},
  onSuccess = () => {},
  onError = () => {},
) => {
  const endPoint = 'api/fuel/full-list';
  onEndPoint(endPoint);

  const { result, error } = await getData(endPoint, payload);
  if (error) return onError(error);
 
  handleListResult(result, true);
  return onSuccess(result);
};

export const getFuelById = async (payload, isView) => {
  const fuelId = Number(payload?.id) || 0;
  if (fuelId === 0) return {};

  const { result, error } = await getData('api/fuel/detail', { fuelId });
  if(error) return {};
  
  const quantity = result.quantity;
  result.quantity = formatQuantity(quantity);
  result.cardNumber = StringUtils.getLastNChars(result.cardNumber, 4);

  if(result.onlyView || isView){
    // result.paidDate = formatDate(result.paidDate, 'dd/MM/yyyy');
    result.totalPrice = calculateTotalFuel(quantity, result.price);
  }
  
  return result;
};

export const getFuelSummary = async () => {
  const { result } = await getData('api/fuel/summary');
  if(result){
    result.startAt = formatDate(result.startAt, 'dd/MM/yyyy');
    result.endAt = formatDate(result.endAt, 'dd/MM/yyyy');
  }
  return result;
};

function handleListResult(items, calTotal = false) {
  const seconds = currentSeconds();

  items.forEach((element) => {
    element.paidDay = formatDate(element.fuelDate, 'dd/MM/yy');
    element.quantity = formatQuantity(element.fuelQuantity);

    if(element.fuelPrice)
      element.price = element.fuelPrice.toLocaleString();

    if(element.cardNumber)
      element.cardNumber = StringUtils.getLastNChars(element.cardNumber, 4);

    if(calTotal){
      element.totalPrice = calculateTotalFuel(element.fuelQuantity, element.fuelPrice);
      if(!element.partnerId){
        element.paymentColor = paymentColor(element.paymentStatus);
      }
    }

    element.dayColor = dayColor(element.createdAt, seconds);
  });
}
